import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './GenericModal.css'
import {Modal} from 'react-overlays'
import Box from '$src/common/Box'

@observer
export default class GenericModal extends Component<
  {css?: any; show?: boolean; onHide: Function; withPadding?: boolean; setContainerRef?: Function},
  {}
> {
  containerEl: any

  setContainer = (ref: any) => {
    this.containerEl = ref
    if (this.props.setContainerRef) this.props.setContainerRef(ref)
  }

  registerClickOnContainer = (e: any) => {
    if (e.target === this.containerEl) {
      this.props.onHide()
    }
  }

  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)
    const {show, onHide} = props

    return (
      <Modal
        backdropClassName={css.modalBackdrop}
        container={document.body}
        show={show === false ? false : true}
        onHide={onHide}
      >
        <div
          {...classes('container', props.withPadding === true && 'withPadding')}
          ref={this.setContainer}
          onClick={this.registerClickOnContainer}
        >
          <Box onDarkBackground={true} css={[{container: css.box}, props.css && props.css.box]}>
            {props.children}
          </Box>
        </div>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/GenericModal.tsx